import { get } from 'lodash';
import {
	SET_PAYEES,
	REMOVE_PAYEE,
	GET_ALL_BENEFICIARIES_SUCCESS,
	GET_BENEFICIARY_DETAILS_BY_ID_SUCCESS,
} from './actions';
import { MULTI_BENEFICIARY_CREATE_SUCCESS } from '../../managePayee/states/action';
import { filterForPayeesInFileUpload } from '../../utils/benImportUtils';
import { SUBMIT_ADD_INTERNATIONAL_PAYEE_SUCCESS, SUBMIT_ADD_PAYEE_SUCCESS } from '../../payees/states/addPayee/actions';
import { GET_PAYEE_SRD_CHECK_REQUEST, GET_PAYEE_SRD_CHECK_SUCCESS, GET_PAYEE_SRD_CHECK_FAILURE } from './actions';

export const buildNewPayeeResponse = (
	{
		id,
		name,
		reference,
		display_name,
		single_use,
		sort_code,
		account_number,
		reference_high_value,
		address,
		cop_account_type,
		cop_account_name,
		confirmation_of_payee,
	},
	{ account, type }
) => ({
	id,
	account: {
		id: account.id,
		sort_code: account.sortCode,
		account_number: account.accountNumber,
	},
	to_account: {
		name,
		sort_code,
		account_number,
	},
	reference,
	display_name,
	singleUse: single_use,
	reference_high_value,
	address,
	type,
	cop_account_name,
	cop_account_type,
	confirmation_of_payee,
});

export const buildInternationalPayeeResponse = (
	{
		id,
		name,
		account_number,
		iban,
		bic,
		clearing_code,
		display_name,
		reference_high_value,
		address,
		bank,
		default_currency,
	},
	account
) => ({
	id,
	account: {
		id: account.id,
		sort_code: account.sortCode,
		account_number: account.accountNumber,
	},
	to_account: {
		name,
		account_number,
		iban,
		bic,
		clearing_code,
	},
	display_name,
	reference_high_value,
	address: {
		address_line_1: address.address_line_1,
		address_line_2: address.address_line_2,
		city: address.city,
		postal_code: address.postal_code,
		country: address.country,
	},
	bank: {
		name: get(bank, 'name', ''),
		address: {
			address_line_1: get(bank, 'address.address_line_1', ''),
			address_line_2: get(bank, 'address.address_line_2', ''),
			city: get(bank, 'address.city', ''),
			postal_code: get(bank, 'address.postal_code', ''),
			country: get(bank, 'address.country', ''),
		},
	},
	default_currency,
	type: 'international',
});

export const deletePayee = (payees, selectedPayeeId) => payees.filter((payee) => payee.id !== selectedPayeeId);

export const buildMultiBeneficiaryPayeeResponse = ({ apiResponses }, { isPaymentFlow, account, type }) =>
	apiResponses
		.filter((response) => filterForPayeesInFileUpload(response, isPaymentFlow))
		.map((response) =>
			buildNewPayeeResponse(
				{
					...response.body,
				},
				{ account, type }
			)
		);

const reducer = (state = [], action) => {
	switch (action.type) {
		case SET_PAYEES:
			return [...state, ...action.payees];
		case MULTI_BENEFICIARY_CREATE_SUCCESS:
			return [...state, ...buildMultiBeneficiaryPayeeResponse(action.payload, action.meta)];
		case SUBMIT_ADD_PAYEE_SUCCESS: {
			if (action.meta.isPaymentFlow) {
				return [...state, buildNewPayeeResponse(action.payload, action.meta)];
			}
			return state;
		}
		case SUBMIT_ADD_INTERNATIONAL_PAYEE_SUCCESS: {
			if (action.meta.isPaymentFlow) {
				return [...state, buildInternationalPayeeResponse(action.payload, action.meta.account)];
			}
			return state;
		}
		// TODO: Need further cleanup below are not required any more.
		// case SUBMIT_DELETE_PAYEE_SUCCESS: {
		// 	return deletePayee(state, action.meta.selectedPayeeId);
		// }
		case GET_ALL_BENEFICIARIES_SUCCESS:
			return [...action.payload.beneficiaries];
		case REMOVE_PAYEE:
			return state.filter((payee) => action.payeeId !== payee.id);
		case GET_BENEFICIARY_DETAILS_BY_ID_SUCCESS:
			if (get(action, 'payload.is_active')) return [...state, action.payload];
			return state;
		case GET_PAYEE_SRD_CHECK_REQUEST:
			return state;
		case GET_PAYEE_SRD_CHECK_SUCCESS:
			const apiResponse = action.payload;
			const {
				srd_check_outcome: { identification, cop_check_required },
			} = apiResponse;
			const stateWithSrdCheck = state.map((payee) => {
				const {
					to_account: { account_number, sort_code },
				} = payee;
				if (account_number && sort_code) {
					const sortCodeAccountNumberConcat = sort_code.concat(account_number);
					if (sortCodeAccountNumberConcat === identification) {
						payee.isCopCheckRequired = cop_check_required;
					}
				}
				return payee;
			});
			return stateWithSrdCheck;
		case GET_PAYEE_SRD_CHECK_FAILURE:
			return state;
		default:
			return state;
	}
};
export default reducer;
